import GenericDB from './generic-db';

export default class NotificationSettingsDB extends GenericDB {
  constructor() {
    super('notificationSettings');
  }

  // Here you can extend ReferalsDB with custom methods
}
